module.exports = __webpack_public_path__ + "static/media/wordpress-ai-option-es.9a344ba5.png";